
/**
 * Export `isProduction`
 */

export function isProduction() {
  return process.env.NODE_ENV === 'production'; // eslint-disable-line no-process-env
}



// WEBPACK FOOTER //
// ../src/core/utils/environment.js